import { useRouteError } from "react-router"
import { useTranslation } from "react-i18next"
import { Button, Heading } from "@tutellus/tutellus-components"
import { LOGO } from "../../../js/const/logos"
import styles from "./index.module.css"

interface ErrorDisplayProps {
  error: { status?: number; message?: string } | null
  onButtonClick: () => void
}

export function ErrorDisplay({ error, onButtonClick }: ErrorDisplayProps) {
  const { t } = useTranslation("error")

  const UNKNOWN_ERROR = {
    title: t("title"),
    subtitle: t("description"),
  }

  const NOT_FOUND_ERROR = {
    title: t("notFound.title"),
    subtitle: t("notFound.description"),
  }

  const ErrorMessagesByHTTPCode: { [key: number]: { title: string; subtitle: string } } = {
    404: NOT_FOUND_ERROR,
    500: UNKNOWN_ERROR,
  }

  const errorStatus = error?.status ?? 500
  const errorMessage = error?.message
  const errorContext = ErrorMessagesByHTTPCode[errorStatus] ?? UNKNOWN_ERROR
  const { title, subtitle } = errorContext

  return (
    <div className={styles.main}>
      <img className={styles.image} src={LOGO} />
      <Heading as="h1">{title}</Heading>
      <p>{subtitle}</p>
      {errorMessage && <p className={styles.error}>Error: {errorMessage}</p>}
      <Button onClick={onButtonClick}>{t("backHome")}</Button>
    </div>
  )
}

export function ErrorTemplate() {
  const error = useRouteError() as { status?: number } | null

  return <ErrorDisplay error={error} onButtonClick={() => (window.location.href = "/")} />
}
